// extracted by mini-css-extract-plugin
module.exports = {"img":"style_img__e2Uqt"};